import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

import { Link } from '../../gatsby-helpers'

const IconLink = ({ classNames, icon, label, href, target, block }) => (
  <Link
    className={cn('IconLink', { block }, classNames)}
    href={href}
    target={target}
  >
    {icon}
    {label && <div className="IconLink__label">{label}</div>}
  </Link>
)

IconLink.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.node.isRequired,
  label: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  block: PropTypes.bool
}

export default IconLink
